import React from 'react';
import SubnavItemExternal from '@molecules/SubnavItemExternal';
import SubnavMobileStyled from '../../../_atoms/SubnavMobileStyled';

const MarketplacesIQMobileSubnav = () => {
    return (
        <SubnavMobileStyled>
            <SubnavItemExternal
                label="Get Started"
                to="https://www.narrpr.com/commercial?ssocode=usicsc-n&cbcode=usicsc-n"
                target="_blank"
            />

            <SubnavItemExternal label="Learn More" to="https://www.icsc.com/marketplacesiq" target="_self" />
            {/* <SubnavItemExternal label="Learn More" to="/marketplaces-iq" target="_self" /> */}
        </SubnavMobileStyled>
    );
};

export default MarketplacesIQMobileSubnav;
